import GameDetailsInline from "@casino/legacy/client/shared/game/GameDetailsInline";
import Translate from "@casino/legacy/client/shared/i18n/Translate";

type Props = { translateId: string };

const GameDetailsRow: FC<Props> = ({ translateId, children }) => (
  <GameDetailsInline>
    <p className="text-base text-muted-foreground">
      <Translate id={translateId} />
    </p>
    <p className="text-base text-foreground">{children}</p>
  </GameDetailsInline>
);

export default GameDetailsRow;
